import React, { useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import logging from 'src/config/logging';
import { IPage } from 'src/interfaces';

const AboutPage: React.FC<IPage> = ({ name }) => {
  const { id } = useParams();

  useEffect(() => {
    logging.info(`Load about with id ${id}`);
  }, [id]);

  useEffect(() => {
    logging.info(`loading ${name}`);
  }, []);

  return (
    <NavLink to="/" end>
      Go login
    </NavLink>
  );
};

export default AboutPage;
